import { Injectable } from '@angular/core';

import { ObjectCheckerService } from '../../../../../services/object-checker.service';
import { StageService } from '../../../../../services/stage.service';
import { CollisionService } from '../../../../../services/collision/collision.service';
import { WallCutService } from '../../../../../services/wall/wall-cut.service';
import { ConstantsService } from '../../../../../services/constants.service';
import { CameraService } from '../../../../../services/camera.service';
import { WallObjectHandler } from './WallObjectHandler';
import { HelperLinesService } from '../../../../../services/helper-lines.service';
import { getWallSize } from '../../../../../services/wall/utils/get-wall-size';
import { mountableObjectIsWithinWallArea } from '../../../../../services/wall/utils/mountable-object-is-within-wall-area';

declare const THREE: any;

@Injectable()
export class WallMountableObjectHandler extends WallObjectHandler {
  protected matrix = new THREE.Matrix4();
  protected wallBox = new THREE.Box3();
  protected objectBox = new THREE.Box3();
  protected objectBoxCenter = new THREE.Vector3();
  protected objectBoxSize = new THREE.Vector3();

  constructor(
    protected objectCheckerSrvc: ObjectCheckerService,
    protected stageService: StageService,
    protected collisionSrvc: CollisionService,
    protected wallCutSrvc: WallCutService,
    protected constants: ConstantsService,
    protected cameraSrvs: CameraService,
    private constantsService: ConstantsService
  ) {
    super(stageService);
  }

  protected _calculateNewPosition(wall, wallIntersectionPoint, objectEntity) {
    wall.getWorldDirection(this._wallDirection);
    if (this.cameraSrvs.isIn2D()) {
      this._position.copy(wall.position);
      wall.parent.localToWorld(this._position);
      const offset = this._position.sub(wallIntersectionPoint);
      const wallSize = getWallSize(wall);
      offset.projectOnVector(this._wallDirection);
      this._position.copy(
        wallIntersectionPoint
          .add(offset)
          .add(this._wallDirection.multiplyScalar(wallSize.z / 2 + objectEntity.width / 2))
          .add(new THREE.Vector3(0, -1, 0).multiplyScalar(objectEntity.height / 2))
      );
    } else {
      const offset = this._wallDirection.multiplyScalar(objectEntity.width / 2);
      this._position.copy(wallIntersectionPoint.add(offset));
    }
    // HelperLinesService.buildOneTestLineAndUpdate(this._position, 4, `awning-position-box`);
    return this._position;
  }

  canExecute(entity) {
    return this.objectCheckerSrvc.isWallMountable(entity);
  }

  dragBegin(intersection) {
    const { object: wall, point: intersectionPoint } = intersection[0];
    const wallMountables = (wall.children || []).filter(child =>
      this.objectCheckerSrvc.isWallMountable(child)
    );
    const staticObjs = [...wallMountables, wall.parent];
    const ghostObject = this.ghostObject;
    let handled = false;
    const entity = ghostObject.userData.entity;
    const position = this._calculateNewPosition(wall, intersectionPoint, entity);
    const collided = this.collisionSrvc.isCollide(ghostObject, staticObjs, {
      newPosition: position
    });

    const objectIsWithinWallArea = mountableObjectIsWithinWallArea(
      wall,
      entity,
      position,
      new THREE.Euler(0, wall.rotation.y, 0)
    );

    if (!collided && objectIsWithinWallArea) {
      handled = true;
      ghostObject.userData.wallId = wall.id;
      const wallDirection = wall.getWorldDirection(new THREE.Vector3(0, 0, 0));
      const ghostObjectDirection = ghostObject.getWorldDirection(new THREE.Vector3(0, 0, 0));
      const angle = wallDirection.angleTo(ghostObjectDirection);
      ghostObject.rotateOnWorldAxis(new THREE.Vector3(0, 1, 0), angle);
      ghostObject.position.copy(position);
      ghostObject.userData.parent = wall;
    }

    return handled;
  }

  dragEnd(object) {}
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/ObjectAdd/Handlers/wallHandlers.ts/WallMountableObjectHandler.ts